import { Module } from "vuex";

import * as firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";
import { CommentSenderRoleEnum } from "@/enums/CommentSenderRoleEnum";
import { batchUpdate } from "@/utils/batchUpdate";
import { serializer } from "@/api/shared/serializer";

const messagesModule: Module<any, any> = {
  namespaced: false,
  state: {
    residentMessagesMonth: [],
    familyMessagesMonth: []
  },
  mutations: {
    setResidentMessages(state: any, payload: []) {
      state.residentMessagesMonth = payload;
    },
    setFamilyMessages(state: any, payload: []) {
      state.familyMessagesMonth = payload;
    }
  },
  actions: {
    async getResidentMessages({commit}, { residentId, duration }) {
      const fromDate = Number(moment(new Date()).subtract(duration, "days").format("x"));

      const residentMessage = firebase
        .firestore()
        .collection("messages")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("residentId", "==", residentId)
        .where("createdAt", ">=", fromDate);

      await residentMessage.get().then(querySnapshot => {
        const resList: Array<any> = [];
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          thisRes.id = x.id;
          thisRes.start = moment(thisRes.createdAt).toDate();
          resList.push(thisRes);
        });
        commit("setResidentMessages", resList);
      });
    },
    async getFamilyMessages({commit}, { familyId, duration }) {
      const fromDate = Number(moment(new Date()).subtract(duration, "days").format("x"));

      const familyMessage = firebase
        .firestore()
        .collection("messages")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("familyHubUserId", "==", familyId)
        .where("createdAt", ">=", fromDate);

      await familyMessage.get().then(querySnapshot => {
        const resList: Array<any> = [];
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          thisRes.id = x.id;
          thisRes.start = moment(thisRes.createdAt).toDate();
          resList.push(thisRes);
        });
        commit("setFamilyMessages", resList);
      });
    },
    async readIncomingFamilyMessages({ commit }, channel) {
      try {
        const snap = await firebase.firestore().collection("messages")
          .where('facilityId', '==', this.state.authModule.currentFacility)
          .where('read', '==', false)
          .where('channel', '==', channel).get()
        
        const itemsToUpdate = snap.docs.map(n => {
          const itemToUpdate = { docId: n.id, updates: { read: true, readDateTime: new Date() } }
          return itemToUpdate
        })

        const result = await batchUpdate('messages', itemsToUpdate)
        console.log('read messages result: ', result)
        if (result.status === 200) return true
        else return false
      }
      catch (error) {
        return false
      }
    },
    async readIncomingFamilyMessage({ commit }, messageId) {
      try {
        const snap = await firebase.firestore().collection("messages").doc(messageId).get()

        if(snap.data().from === CommentSenderRoleEnum.Staff){
          return false
        }

        snap.ref.update({ read: true, readDateTime: moment().toISOString()})
        return true
      }
      catch (error) {
        return false
      }
    },
    async createMessage({ dispatch }, data) {
      try {
        data.facilityId = this.state.authModule.currentFacility
        data.createdAt = new Date().toISOString()
        const res = await firebase.firestore().collection("messages").add(data)
        data.id = res.id

        return data
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
};

export default messagesModule;
